import { useUserStore } from '@/shared/stores/user'
import { openDialog, Dialog } from '@/shared/dialogs/dialog'

export const useInfringementTools = () => {
  const userStore = useUserStore()

  const openChecker = () => openDialog(Dialog.Checker)

  const openReport = () => {
    if (!userStore.user) return
    openDialog(
      userStore.user.reportCredits
        ? Dialog.CreateReport
        : Dialog.InfringementReport
    )
  }

  return { openChecker, openReport }
}
